import { useState } from 'react';
import ResidentialDetails from './ResidentialDetails';
import Selfie from './Selfie';
import { PersonalInfo } from './PersonalInfo';
import AccountVerificationDoc from './AccountVerificationDoc';
import InstitutionDetails from './InstitutionDetails';
import './CustomerProfile.scss';
import DeleteIcon from '../../../svgs/DeleteIcon';
import RolesAndPermissionGuard from '../../../components/RolesAndPermissionGuard';
import ErrorPermissionModalComp from '../../../components/ErrorPermissionModalComp';
import DeleteCustomerProfile from '../DeleteCustomerProfile';

interface ICustomerProfile{
  payload:any;
  refetchCustomerById?:any;
  customerId?:string;
  disableForms?: boolean;
}
const CustomerProfile = ({
  payload, disableForms, refetchCustomerById, customerId,
}:ICustomerProfile) => {
  const [deleteCustomerProfileModal, setDeleteCustomerProfileModal] = useState(false);
  const isStudent = payload?.userRtDetail?.enrollment_type === 'student';
  const isSelfieDone = !!payload?.userRtDetail?.selfie;

  const indexFunction = (profileComponentName) => {
    switch (profileComponentName) {
    case 'Selfie':
      return isSelfieDone ? 1 : 0;
    case 'PersonalInfo':
      return isSelfieDone ? 2 : 1;
    case 'InstitutionDetails':
      return isSelfieDone ? 3 : 2;
    case 'ResidentialDetails':
      return isSelfieDone && isStudent ? 4 : !isStudent && !isSelfieDone ? 2 : 3;
    case 'AccountVerificationDoc':
      return isSelfieDone && isStudent ? 5 : !isStudent && !isSelfieDone ? 3 : 4;
    default:
      return 0;
    }
  };

  return (
    <div className="customer-profile-cover">
      {payload?.userRtDetail?.selfie && <Selfie src={`${payload?.userRtDetail?.selfie}?modified=${Date.now()}`} index={indexFunction('Selfie')} />}
      {payload?.id && payload?.firstName && (
        <PersonalInfo
          index={indexFunction('PersonalInfo')}
          payload={payload}
          buttonState={false}
        />
      )}

      {isStudent && (
        <InstitutionDetails
          index={indexFunction('InstitutionDetails')}
          payload={payload}
        />
      )}
      {payload?.primaryAddress && (
        <ResidentialDetails
          index={indexFunction('ResidentialDetails')}
          disableMode={disableForms}
          payload={payload?.primaryAddress}
          buttonState={false}
        />
      )}

      {payload?.documents?.length !== 0 && (
      <AccountVerificationDoc
        index={indexFunction('AccountVerificationDoc')}
        payload={payload}
        fetchUser={refetchCustomerById}
      />
      )}
      <div className="delete-user-profile" onClick={() => setDeleteCustomerProfileModal(true)} style={{ cursor: 'pointer' }}>
        <DeleteIcon className="delete-user" />
        <div className="delete-user-label">Delete</div>
      </div>

      {deleteCustomerProfileModal && (
        <RolesAndPermissionGuard permissionName="can-remove-user" hasErrorTemplate={<ErrorPermissionModalComp closeModal={() => setDeleteCustomerProfileModal(false)} />}>
          <DeleteCustomerProfile
            customerId={customerId}
            closeModal={() => {
              setDeleteCustomerProfileModal(false);
              refetchCustomerById({ variables: { id: customerId } });
            }}
            isShow={deleteCustomerProfileModal}
          />
        </RolesAndPermissionGuard>
      )}
    </div>
  );
};

export default CustomerProfile;
